<template>
  <div>
    <app-cells>
      <app-button @click.native="onShowModal">Import</app-button>
    </app-cells>
    <app-cells>
      <div class="date-picker-wrapper">
        <VueCtkDateTimePicker
          id="date_picker_balance"
          class="custom-date-time-picker custom-date-time-picker--range"
          v-model="filter_dates"
          :custom-shortcuts="custom_shortcuts"
          @is-hidden="onIsHiddenPicker"
          format="YYYY-MM-DD"
          formatted="ll"
          label="Select dates"
          color="#77b017"
          button-color="#77b017"
          overlay
          no-header
          no-label
          locale="en"
          range
        />
        <div v-if="date_picker_error" class="date-picker-wrapper__error">Choose an end date</div>
      </div>
      <app-input
        @input.native="onSearch"
        v-model="filter_search"
        class="input--300"
        type="search"
        placeholder="Search"
        name="search_invoice"
      />
      <app-select
        @input="onChangeFilter"
        v-model="filter_account"
        :options="account_options"
        :reduce="item => item.id"
        placeholder="Account"
        class="select--300"
      />
    </app-cells>
    <app-spinner v-if="!page_loaded" />
    <template v-else>
      <app-cells><h2 class="title">Unallocated Outcome</h2></app-cells>
      <v-client-table
        :data="table_outcome.items"
        :columns="table_outcome.columns"
        :options="table_outcome.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_outcome }"
      >
        <template #h__account><div class="table-default__left">Account</div></template>
        <template #h__reference><div class="table-default__left">Reference</div></template>
        <template #h__description><div class="table-default__left">Description</div></template>
        <template #h__select>
          <label
            v-if="table_outcome.items.length"
            class="checkbox checkbox--table"
            :class="{ 'checkbox--readonly': checked_income.length }"
          >
            <input
              v-model="checked_all_outcome"
              type="checkbox"
              name="checked_all_outcome"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #select="{ row }">
          <label class="checkbox checkbox--table" :class="{ 'checkbox--readonly': checked_income.length }">
            <input
              v-model="checked_outcome"
              type="checkbox"
              :value="row.id"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #account="{ row }"><div class="table-default__left table-default__nowrap">{{ row.account.name }}</div></template>
        <template #date="{ row }"><span class="table-default__nowrap">{{ dateFormat(row.timestamp) }}</span></template>
        <template #reference="{ row }"><div class="table-default__left">{{ row.reference }}</div></template>
        <template #description="{ row }"><div class="table-default__left">{{ row.description }}</div></template>
        <template #amount="{ row }">
          <span class="table-default__nowrap" :class="{'table-default__text-green': row.type === 1, 'table-default__text-red': row.type === 2}">
          {{ amountFormat(row.amount) }} {{ row.account.currency.code }}
          </span>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationOutcome"
            v-if="pagination_outcome.pages > 1"
            v-model="pagination_outcome.page"
            :page-count="pagination_outcome.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_outcome.count" :count="table_outcome.items.length" :page="pagination_outcome.page" :limit="40" />
      </app-cells>
      <app-cells><h2 class="title">Unallocated Income</h2></app-cells>
      <v-client-table
        :data="table_income.items"
        :columns="table_income.columns"
        :options="table_income.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_income }"
      >
        <template #h__account><div class="table-default__left">Account</div></template>
        <template #h__reference><div class="table-default__left">Reference</div></template>
        <template #h__description><div class="table-default__left">Description</div></template>
        <template #h__select>
          <label
            v-if="table_income.items.length"
            class="checkbox checkbox--table"
            :class="{ 'checkbox--readonly': checked_outcome.length }"
          >
            <input
              v-model="checked_all_income"
              type="checkbox"
              name="checked_all_income"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #select="{ row }">
          <label class="checkbox checkbox--table" :class="{ 'checkbox--readonly': checked_outcome.length }">
            <input
              v-model="checked_income"
              type="checkbox"
              :value="row.id"
            />
            <span class="checkbox__checkmark"></span>
          </label>
        </template>
        <template #account="{ row }"><div class="table-default__left table-default__nowrap">{{ row.account.name }}</div></template>
        <template #date="{ row }"><span class="table-default__nowrap">{{ dateFormat(row.timestamp) }}</span></template>
        <template #reference="{ row }"><div class="table-default__left">{{ row.reference }}</div></template>
        <template #description="{ row }"><div class="table-default__left">{{ row.description }}</div></template>
        <template #amount="{ row }">
          <span class="table-default__nowrap" :class="{'table-default__text-green': row.type === 1, 'table-default__text-red': row.type === 2}">
          {{ amountFormat(row.amount) }} {{ row.account.currency.code }}
          </span>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationIncome"
            v-if="pagination_income.pages > 1"
            v-model="pagination_income.page"
            :page-count="pagination_income.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_income.count" :count="table_income.items.length" :page="pagination_income.page" :limit="40" />
      </app-cells>
      <app-cells><h2 class="title">Allocated</h2></app-cells>
      <v-client-table
        :data="table_allocated.items"
        :columns="table_allocated.columns"
        :options="table_allocated.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_allocated }"
      >
        <template #h__account><div class="table-default__left">Account</div></template>
        <template #h__reference><div class="table-default__left">Reference</div></template>
        <template #h__description><div class="table-default__left">Description</div></template>
        <template #h__rule><div class="table-default__left">Rule</div></template>
        <template #account="{ row }"><div class="table-default__left table-default__nowrap">{{ row.account.name }}</div></template>
        <template #date="{ row }"><span class="table-default__nowrap">{{ dateFormat(row.timestamp) }}</span></template>
        <template #reference="{ row }"><div class="table-default__left">{{ row.reference }}</div></template>
        <template #description="{ row }"><div class="table-default__left">{{ row.description }}</div></template>
        <template #amount="{ row }">
          <span class="table-default__nowrap" :class="{'table-default__text-green': row.type === 1, 'table-default__text-red': row.type === 2}">
          {{ amountFormat(row.amount) }} {{ row.account.currency.code }}
          </span>
        </template>
        <template #rule="{ row }"><div class="table-default__left">{{ row.rule?.description || row.rule?.pattern || '-' }}</div></template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationAllocated"
            v-if="pagination_allocated.pages > 1"
            v-model="pagination_allocated.page"
            :page-count="pagination_allocated.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_allocated.count" :count="table_allocated.items.length" :page="pagination_allocated.page" :limit="40" />
      </app-cells>
      <app-cells><h2 class="title">Import</h2></app-cells>
      <v-client-table
        :data="table_import.items"
        :columns="table_import.columns"
        :options="table_import.options"
        class="table-default"
        :class="{ 'table-default--loading': table_preloader_import }"
      >
        <template #h__account><div class="table-default__left">Account</div></template>
        <template #account="{ row }"><div class="table-default__left">{{ row.account.name }}</div></template>
        <template #status="{ row }">
          <span class="status-tag" :style="{ backgroundColor: row.status.color }">{{ row.status.name }}</span>
        </template>
        <template #imported_by="{ row }">
          <div v-if="row.created_by" class="table-default__controls">
            <div class="table-default__photo">
              <img
                :src="getUserAvatar(row.created_by.crop.crop_url)"
                alt="Avatar"
                v-tooltip="{ content: row.created_by.full_name, placement: 'top-start', offset: 10 }"
              >
            </div>
            {{ dateFormat(row.created_at) }}
          </div>
          <span v-else>-</span>
        </template>
        <template #attachment="{ row }">
          <div class="table-default__controls">
            <button
              @click="onDownloadFile(row.file, row)"
              type="button"
            >
              <img src="@/assets/img/download-table-blue-icon.svg" alt="">
            </button>
          </div>
        </template>
      </v-client-table>
      <app-cells position="between">
        <div>
          <paginate
            :clickHandler="onClickPaginationImport"
            v-if="pagination_import.pages > 1"
            v-model="pagination_import.page"
            :page-count="pagination_import.pages"
            :prev-text="'<'"
            :next-text="'>'"
            :container-class="'pagination'"
            :page-class="'pagination__item'"
            :page-link-class="'pagination__link'"
            :prev-class="'pagination__item pagination__item--prev'"
            :next-class="'pagination__item pagination__item--next'"
            :next-link-class="'pagination__link pagination__link--next'"
            :prev-link-class="'pagination__link pagination__link--prev'"
          />
        </div>
        <app-table-records :all="pagination_import.count" :count="table_import.items.length" :page="pagination_import.page" :limit="5" />
      </app-cells>
      <div class="flying-block" :class="{ 'flying-block--show': is_show_flying_block }">
        <div class="flying-block__text">
          Selected items: {{ checked_income.length || checked_outcome.length }}
        </div>
        <app-button @click.native="onShowAllocateModal" >Allocate</app-button>
      </div>
    </template>
    <modal
      name="import_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
      class="modal-not-overflow"
      draggable=".popup__title"
    >
      <div class="popup">
        <button @click="$modal.hide('import_modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Import NMB Statement</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm('form', 'sendImport')">
            <app-form-group label="File" required>
              <app-uploader
                @onAddedFile="onFileAdded"
                v-model="form.file"
                :extensions="['text/csv']"
                formDataFormats="CSV"
              />
              <template #error>
                <div v-for="(error, index) in file_errors" :key="index">{{ error }}</div>
              </template>
            </app-form-group>
            <template v-if="account_number">
              <app-form-group label="Account Number">
                <app-input
                  v-model="account_number"
                  readonly
                />
              </app-form-group>
              <app-form-group label="Account Name">
                <app-input
                  v-model="account_name"
                  readonly
                />
              </app-form-group>
              <app-cells position="center" :indent="false">
                <app-button ref="submit" type="submit">Import</app-button>
              </app-cells>
            </template>
          </form>
        </div>
      </div>
    </modal>
    <modal
      name="allocate_modal"
      :width="400"
      :height="'auto'"
      :scrollable="true"
      :adaptive="true"
      :clickToClose="false"
      :reset="true"
      class="modal-not-overflow"
      draggable=".popup__title"
    >
      <div class="popup">
        <button @click="$modal.hide('allocate_modal')" class="popup__close" type="button"></button>
        <div class="popup__title">Allocate</div>
        <div class="popup__body">
          <form @submit.prevent="onCheckForm('form_allocate', 'sendAllocate')">
            <app-form-group label="Supplier">
              <app-select
                @input="onSelectSupplier"
                @search="onSupplierSearch"
                v-model="form_allocate.supplier"
                :options="supplier_options"
                :filterBy="() => true"
                :display-field="option => `${option.trade_name === option.legal_name ? option.trade_name : `${option.trade_name} (${option.legal_name})`}`"
                label="trade_name"
                placeholder="Supplier"
              />
            </app-form-group>
            <app-form-group v-if="checked_income.length" label="Item" required>
              <app-select
                v-model="form_allocate.item"
                :options="transaction_items_options_income"
                :clearable="false"
                label="name_revenue"
                placeholder="Item"
                :error="$v.form_allocate.item.$error"
              />
              <template #error>
                <div v-if="$v.form_allocate.item.$dirty && !$v.form_allocate.item.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group v-else label="Item" required>
              <app-select
                v-model="form_allocate.item"
                :options="transaction_items_options_outcome"
                :clearable="false"
                label="name_expense"
                placeholder="Item"
                :error="$v.form_allocate.item.$error"
              />
              <template #error>
                <div v-if="$v.form_allocate.item.$dirty && !$v.form_allocate.item.required">Required field</div>
              </template>
            </app-form-group>
            <app-form-group label="Notes" label-for="notes">
              <app-textarea
                v-model="form_allocate.description"
                rows="5"
                placeholder="Notes"
                id="notes"
              />
            </app-form-group>
            <app-cells position="center" :indent="false">
              <app-button ref="submit_allocate" type="submit">Allocate</app-button>
            </app-cells>
          </form>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import {
  getAdministrativeSuppliers,
  getFinanceAccounts,
  getFinanceCashflowReconciliation,
  getFinanceCashflowReconciliationAccountFiles,
  getFinanceTransactionsItemsList,
  postFinanceCashflowReconciliationTransactions,
  getFinanceCashflowReconciliationImportNMBValidate,
  postFinanceCashflowReconciliationImportNMB
} from '@/http'
import moment from 'moment/moment'
import debounce from 'lodash/debounce'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import axios from 'axios'
import { format, parseISO } from 'date-fns'

export default {
  name: 'FinanceCashflowReconciliationNMB',
  components: { VueCtkDateTimePicker },
  data() {
    return {
      page_loaded: false,
      form: {},
      form_allocate: {},
      account_options: [],
      filter_dates: null,
      date_picker_error: false,
      filter_account: null,
      filter_search: '',
      checked_all_income: false,
      checked_all_outcome: false,
      checked_income: [],
      checked_outcome: [],
      transaction_items_options_income: [],
      transaction_items_options_outcome: [],
      supplier_options: [],
      is_show_flying_block: false,
      custom_shortcuts: [
        {
          key: 'next30Days',
          label: 'Next 30 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(30, 'days')
            }
          }
        },
        {
          key: 'next60Days',
          label: 'Next 60 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(60, 'days')
            }
          }
        },
        {
          key: 'next90Days',
          label: 'Next 90 days',
          value: () => {
            return {
              start: moment(),
              end: moment().add(90, 'days')
            }
          }
        },
        { key: 'last30Days', label: 'Last 30 days', value: 30 },
        { key: 'thisYear', label: 'This year', value: 'year' },
      ],
      table_income: {
        items: [],
        columns: [
          'select',
          'date',
          'account',
          'amount',
          'reference',
          'description',
        ],
        options: {
          headings: {
            'select': '',
            'account': 'Account',
            'date': 'Date',
            'reference': 'Reference',
            'description': 'Description',
            'amount': 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_income: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_income: false,
      table_outcome: {
        items: [],
        columns: [
          'select',
          'date',
          'account',
          'amount',
          'reference',
          'description',
        ],
        options: {
          headings: {
            'select': '',
            'account': 'Account',
            'date': 'Date',
            'reference': 'Reference',
            'description': 'Description',
            'amount': 'Amount',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_outcome: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_outcome: false,
      table_allocated: {
        items: [],
        columns: [
          'date',
          'account',
          'amount',
          'reference',
          'description',
          'rule',
        ],
        options: {
          headings: {
            'account': 'Account',
            'date': 'Date',
            'reference': 'Reference',
            'description': 'Description',
            'amount': 'Amount',
            'rule': 'Rule',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 40,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_allocated: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_allocated: false,
      table_import: {
        items: [],
        columns: [
          'account',
          'status',
          'imported_by',
          'attachment',
        ],
        options: {
          headings: {
            'account': 'Account',
            'status': 'Status',
            'imported_by': 'Imported by',
            'attachment': 'File',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 5,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
      pagination_import: {
        pages: 1,
        page: 1,
        count: 1,
      },
      table_preloader_import: false,
      account_number: null,
      account_name: null,
      file_errors: [],
      current_page_income: 1,
      current_page_outcome: 1,
    }
  },
  validations: {
    form: {
      file: { required },
    },
    form_allocate: {
      item: { required },
    },
  },
  watch: {
    checked_all_income(value) {
      if (this.current_page_income !== this.pagination_income.page) return
      if (value) {
        this.table_income.items.forEach(item => {
          if (!this.checked_income.includes(item.id)) this.checked_income.push(item.id)
        })
      } else {
        this.checked_income = this.checked_income.filter(item => !this.table_income.items.map(subitem => subitem.id).includes(item))
      }
    },
    checked_income(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_income.length) this.checked_all_income = false
    },
    checked_all_outcome(value) {
      if (this.current_page_outcome !== this.pagination_outcome.page) return
      if (value) {
        this.table_outcome.items.forEach(item => {
          if (!this.checked_outcome.includes(item.id)) this.checked_outcome.push(item.id)
        })
      } else {
        this.checked_outcome = this.checked_outcome.filter(item => !this.table_outcome.items.map(subitem => subitem.id).includes(item))
      }
    },
    checked_outcome(value) {
      this.is_show_flying_block = value.length > 0
      if (!this.checked_outcome.length) this.checked_all_outcome = false
    },
  },
  mounted() {
    Promise.all([
      getFinanceAccounts({bank: 'nmb'}),
      getFinanceTransactionsItemsList({ revenue: true }),
      getFinanceTransactionsItemsList({ expense: true }),
      this.fetchItemsIncome(),
      this.fetchItemsOutcome(),
      this.fetchItemsAllocated(),
      this.fetchItemsImport()
    ])
      .then(response => {
        this.account_options = response[0].data
        this.transaction_items_options_income = response[1].data
        this.transaction_items_options_outcome = response[2].data
        this.page_loaded = true
      })
  },
  methods: {
    async fetchItemsIncome() {
      const response = await getFinanceCashflowReconciliation({
        page: this.pagination_income.page,
        page_size: 40,
        is_allocated: false,
        is_processing: false,
        type: 1,
        source: 'nmb',
        timestamp__gte: this.filter_dates?.start,
        timestamp__lte: this.filter_dates?.end,
        account: this.filter_search ? '' : this.filter_account,
        search: this.filter_search,
      })
      this.table_income.items = response.data.results
      this.pagination_income.pages = response.data.pages
      this.pagination_income.count = response.data.count
      this.table_preloader_income = false
    },
    async fetchItemsOutcome() {
      const response = await getFinanceCashflowReconciliation({
        page: this.pagination_outcome.page,
        page_size: 40,
        is_allocated: false,
        is_processing: false,
        type: 2,
        source: 'nmb',
        timestamp__gte: this.filter_dates?.start,
        timestamp__lte: this.filter_dates?.end,
        account: this.filter_search ? '' : this.filter_account,
        search: this.filter_search,
      })
      this.table_outcome.items = response.data.results
      this.pagination_outcome.pages = response.data.pages
      this.pagination_outcome.count = response.data.count
      this.table_preloader_outcome = false
    },
    async fetchItemsAllocated() {
      const response = await getFinanceCashflowReconciliation({
        page: this.pagination_allocated.page,
        page_size: 40,
        is_allocated: true,
        source: 'nmb',
        timestamp__gte: this.filter_dates?.start,
        timestamp__lte: this.filter_dates?.end,
        account: this.filter_search ? '' : this.filter_account,
        search: this.filter_search,
      })
      this.table_allocated.items = response.data.results
      this.pagination_allocated.pages = response.data.pages
      this.pagination_allocated.count = response.data.count
      this.table_preloader_allocated = false
    },
    async fetchItemsImport() {
      const response = await getFinanceCashflowReconciliationAccountFiles({
        page: this.pagination_import.page,
        page_size: 5,
        created_at__gte: this.filter_dates?.start,
        created_at__lte: this.filter_dates?.end,
        account: this.filter_search ? '' : this.filter_account,
        search: this.filter_search,
      })
      this.table_import.items = response.data.results
      this.pagination_import.pages = response.data.pages
      this.pagination_import.count = response.data.count
      this.table_preloader_import = false
    },
    async onClickPaginationIncome(page) {
      this.pagination_income.page = page
      await this.fetchItemsIncome()
      this.checked_all_income = this.checked_income.some(item => this.table_income.items.map(subitem => subitem.id).includes(item))
      this.$nextTick(() => { this.current_page_income = page })
    },
    async onClickPaginationOutcome(page) {
      this.pagination_outcome.page = page
      await this.fetchItemsOutcome()
      this.checked_all_outcome = this.checked_outcome.some(item => this.table_outcome.items.map(subitem => subitem.id).includes(item))
      this.$nextTick(() => { this.current_page_outcome = page })
    },
    onClickPaginationAllocated(page) {
      this.pagination_allocated.page = page
      this.fetchItemsAllocated()
    },
    onClickPaginationImport(page) {
      this.pagination_import.page = page
      this.fetchItemsImport()
    },
    onFileAdded(e) {
      if (e.id) {
        getFinanceCashflowReconciliationImportNMBValidate(e.id)
          .then(response => {
            if (response.data.is_valid) {
              this.account_number = response.data.extra.account_number
              this.account_name = response.data.extra.account.name
            } else {
              this.file_errors = response.data.errors
              this.account_number = null
              this.account_name = null
            }
          })
      } else {
        this.account_number = null
        this.account_name = null
        this.file_errors = []
      }
    },
    onCheckForm(form, action) {
      this.$v[form].$touch()
      if (this.$v[form].$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        this[action]()
      }
    },
    sendImport() {
      this.$refs.submit.preload = true
      postFinanceCashflowReconciliationImportNMB(this.form.file.id)
        .then(() => {
          this.fetchTables()
          this.$notify({
            type: 'success',
            title: 'File imported',
          })
          this.$modal.hide('import_modal')
          this.account_number = null
        })
        .catch(() => { this.$refs.submit.preload = false })
    },
    sendAllocate() {
      this.$refs.submit_allocate.preload = true
      const data = {...this.form_allocate}
      if (data.supplier) data.supplier = data.supplier.id
      else delete data.supplier
      if (this.checked_income.length) data.reconciliations = this.checked_income
      else data.reconciliations = this.checked_outcome
      data.item = data.item.id
      postFinanceCashflowReconciliationTransactions(data)
        .then(() => {
          if (this.checked_income.length) {
            this.checked_income = []
            this.pagination_income.page = 1
            this.current_page_income = 1
          }
          if (this.checked_outcome.length) {
            this.checked_outcome = []
            this.pagination_outcome.page = 1
            this.current_page_outcome = 1
          }
          this.fetchTables()
          this.$notify({
            type: 'success',
            title: 'Allocated',
          })
          this.$modal.hide('allocate_modal')
        })
        .catch(() => { this.$refs.submit_allocate.preload = false })
    },
    onSelectSupplier(e) {
      if (e?.transaction_item) this.form_allocate.item = e.transaction_item
      else this.form_allocate.item = null
    },
    onShowModal() {
      this.form = {}
      this.$v.form.$reset()
      this.$modal.show('import_modal')
    },
    onShowAllocateModal() {
      this.form_allocate = {
        item: null,
      }
      this.$v.form_allocate.$reset()
      this.$modal.show('allocate_modal')
    },
    async fetchTables() {
      await Promise.all([
        this.fetchItemsIncome(),
        this.fetchItemsOutcome(),
        this.fetchItemsAllocated(),
        this.fetchItemsImport()
      ])
    },
    onIsHiddenPicker() {
      if (this.filter_dates?.start && this.filter_dates?.end) {
        this.date_picker_error = false
        this.fetchTables()
      } else this.date_picker_error = true
    },
    onChangeFilter() {
      this.pagination_income.page = 1
      this.pagination_outcome.page = 1
      this.pagination_allocated.page = 1
      this.pagination_import.page = 1
      this.current_page_income = 1
      this.current_page_outcome = 1
      this.fetchTables()
    },
    onSearch() {
      this.searchItem(this)
    },
    searchItem: debounce(async vm => {
      vm.pagination_income.page = 1
      vm.pagination_outcome.page = 1
      vm.pagination_allocated.page = 1
      vm.pagination_import.page = 1
      vm.current_page_income = 1
      vm.current_page_outcome = 1
      await vm.fetchTables()
      vm.checked_all_income = vm.checked_income.some(item => vm.table_income.items.map(subitem => subitem.id).includes(item))
      vm.checked_all_outcome = vm.checked_outcome.some(item => vm.table_outcome.items.map(subitem => subitem.id).includes(item))
    }, 350),
    onSupplierSearch(search, loading) {
      loading(true)
      this.searchSupplier(loading, search, this)
    },
    searchSupplier: debounce((loading, search, vm) => {
      if (!search) {
        loading(false)
        vm.supplier_options = []
      } else {
        getAdministrativeSuppliers({search}).then(response => {
          vm.supplier_options = response.data
          loading(false)
        })
      }
    }, 350),
    dateFormat(date) {
      return date ? format(parseISO(date), 'dd MMM yyyy') : '-'
    },
    amountFormat(amount) {
      return amount ? new Intl.NumberFormat('ru-RU').format(amount) : '-'
    },
    getUserAvatar(crop_url) {
      if (crop_url) return crop_url
      return require('@/assets/img/temp/avatar-slug.jpg')
    },
    onDownloadFile(doc_obj, row) {
      axios.get(doc_obj.file, { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          const extension = doc_obj.file_name.split('.').pop()
          const part_of_name = `${row.account.name} - ${row.status.name} - ${row.created_by.full_name} - ${this.dateFormat(row.created_at)}`

          link.href = url
          link.setAttribute('download', `${part_of_name}.${extension}`)
          document.body.appendChild(link)
          link.click()
          URL.revokeObjectURL(url)
        })
    },
  }
}
</script>
